import { oqulyqtarApi } from '../api';

const adminApi = oqulyqtarApi.injectEndpoints({
    endpoints: (build) => ({
        getSchools: build.query({
            query: (filters) => ({
                url: `/school/list${filters && filters}`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => [{type:'SchoolList', id: `filters:${arg}`}],
        }),
        getSchool: build.query({
            query: (id) => ({
                url: `/school/view?school_id=${id}`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => [{type: 'School', id: arg}],
        }),
        addSchool: build.mutation({
            query: (payload) => ({
                url: '/school/create',
                method: 'POST',
                body: { ...payload }
            }),
            invalidatesTags: (result = [], error, arg) => ['SchoolList'],
        }),
        editSchool: build.mutation({
            query: ({ id, ...payload }) => ({
                url: `/school/edit?school_id=${id}`,
                method: 'PATCH',
                body: payload
            }),
            invalidatesTags: (result = [], error, arg) => ['SchoolList', {type: 'School', id: arg.id}],
        }),
        deleteSchool: build.mutation({
            query: (id) => ({
                url: `/school/delete?school_id=${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result = [], error, arg) => ['SchoolList', {type: 'School', id: arg}],
        }),
        getCityList: build.query({
            query: (filters) => ({
                url: `/school/city-list`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => ['CityList'],
        })
    })
});

export const {
    useLazyGetSchoolsQuery,
    useLazyGetSchoolQuery,
    useAddSchoolMutation,
    useEditSchoolMutation,
    useDeleteSchoolMutation,
    useGetCityListQuery
} = adminApi;
